import React from "react";
import { InputAdornment } from "@mui/material";
import DKFormNumberInput, { DKFormNumberInputProps } from "./DKFormNumberInput";

const DKFormMoneyInput = (props: DKFormNumberInputProps) => {
  return (
    <DKFormNumberInput
      {...props}
      startAdornment={<InputAdornment position="start">$</InputAdornment>}
    />
  );
};

export default DKFormMoneyInput;
